import { FaGreaterThan } from "react-icons/fa"
import { AiOutlineRight } from "react-icons/ai"
import { NavLink, useLocation } from "react-router-dom"
import jwtDecode from "jwt-decode"

export default function Breadcrumbs({ className, mobileView }) {
  const role = jwtDecode(localStorage.getItem("token")).role
  const location = useLocation()
  const urlPath =
    location.pathname === "/"
      ? role === "Admin"
        ? ["Admin Dashboard"]
        : role === "Student"
        ? ["Dashboard"]
        : role === "Tutor"
        ? ["My Student Dashboard"]
        : role === "Senior Tutor"
        ? ["My Student Dashboard (Senior Tutor)"]
        : role === "School Manager"
        ? ["School Dashboard"]
        : ["Parent Dashboard"]
      : location.pathname.split(/(?=\/)/)

  const filterId = urlPath.filter(value => {
    return !value.includes("/id=") && value !== "/tutor" && value !== "/parent"
  })

  const combinedPath = filterId.reduce((acc, curr) => {
    if (acc.length === 0) {
      acc.push(curr)
    } else {
      acc.push(acc[acc.length - 1] + curr)
    }
    return acc
  }, [])
  return (
    <div
      className={` ${className} heading-4 bread-crumbs flex-wrap items-center font-semibold`}
    >
      {filterId.map((value, index) => (
        <span className="mr-2 flex items-center gap-2 capitalize" key={index}>
          <NavLink
            to={combinedPath[index] === "Dashboard" ? "/" : combinedPath[index]}
            className={`${
              index === filterId.length - 1
                ? "pointer-events-none cursor-default text-primary"
                : "text-neutral-4d underline hover:text-primary "
            }`}
          >
            {value
              .replace(/\/|-/g, " ")
              .replace(/_/g, " ")
              .replace(/~/g, "/")
              .replace(/\./g, "-")
              .trim()}
          </NavLink>
          {index !== filterId.length - 1 &&
            (!mobileView ? (
              <FaGreaterThan
                size={14}
                className="font-normal text-neutral-4d"
              />
            ) : (
              <AiOutlineRight className="font-normal text-neutral-4d" />
            ))}
        </span>
      ))}
    </div>
  )
}
